"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = exports.get = void 0;

var cookieHelper = _interopRequireWildcard(require("../helpers/cookieHelper"));

var hasLocalStorage = false;

try {
  hasLocalStorage = window && window.localStorage;
} catch (err) {
  /* noop */
}

var get = function get() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = '';

  if (hasLocalStorage) {
    try {
      value = window.localStorage[key] || '';
    } catch (err) {
      value = cookieHelper.get(key);
    }
  }

  return value;
};

exports.get = get;

var set = function set() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (hasLocalStorage) {
    try {
      window.localStorage[key] = value || '';
    } catch (err) {
      cookieHelper.set(key, value);
    }
  }

  return value;
};

exports.set = set;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker/static-1.514/js/containers/tempStorage.js
// module id = 570
// module chunks = 5 6